export default [{
	name:'overlays',
	layers:[
		'overlays-visible',
		'overlays-active',
		'overlays-active-lines',
		'overlays-hover',
		'overlays-hover-lines',
		'overlay-labels-visible'
	]
},{
	name:'zoning',
	layers:[
		'zoning',
		'zoning-labels',
		'zoning-lines',
		'zoning-hover-lines',
		'zoning-highlight',
		'zoning-highlight-lines'
	]
},{
	name:'sewer mains',
	layers:[
		'sewer-mains',
		'sewer-mains-active',
		'sewer-mains-hover'
	]
},{
	name:'water mains',
	layers:[
		'water-mains',
		'water-mains-active',
		'water-mains-hover'
	]
},{
	name:'poi',
	layers:[
		'poi',
		'poi-hover',
		'poi-active'
	]
}]


// WEBPACK FOOTER //
// ./src/config/map-layer-groups.js